var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCategoryWork = function SvgCategoryWork(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "category_work_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".category_work_svg__st0{fill:none;stroke:#666;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "category_work_svg__st0",
    d: "M35.7 34.9H12.3c-1.6 0-2.9-1.3-2.9-2.9V19c0-1.6 1.3-2.9 2.9-2.9h23.3c1.6 0 2.9 1.3 2.9 2.9v12.9c.2 1.6-1.1 3-2.8 3zM17.1 20.9v4.5M30.7 20.9v4.5M19.1 16v-3.1c0-.9.9-1.6 2-1.6h5.7c1 0 1.8.6 1.8 1.4v2.9M9.9 23.2h28.4"
  })));
};
export default SvgCategoryWork;